import api from '@edu-fe/api'

const module = {
  name: 'wpsTemplate',
  getDirectory: api.create(`/my/template/home`),
  getLists: (id, pageNo = 1, pageSize = 20) =>
    api.create(`/my/template/list?id=${id}&pageNo=${pageNo}&pageSize=${pageSize}`),
  addFile: (id) => {
    return api.create(`/my/template/add?id=${id}`, {
      method: 'post'
    })
  }
}

export default module
